import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  useSendPasswordResetEmail,
  useSignInWithEmailAndPassword,
} from "react-firebase-hooks/auth";
import "./Login.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SocialLogin from "../SocialLogin/SocialLogin";
import auth from "../../../firebase.init";
import axios from "axios";

const Login = () => {
  const emailRef = useRef("");
  const passwordRef = useRef("");
  const navigate = useNavigate();
  const location = useLocation();

  let from = location.state?.from?.pathname || "/";

  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);

  const [sendPasswordResetEmail, sending] = useSendPasswordResetEmail(auth);
  if (loading) {
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>;
  }
  const navigateRegister = () => {
    navigate("/register");
  };

  const resetPassword = async () => {
    const email = emailRef.current.value;

    if (email) {
      await sendPasswordResetEmail(email);
      toast("Sent email");
    } else {
      toast("Please Enter Your Email");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    await signInWithEmailAndPassword(email, password);

    const { data } = await axios.post(
      "https://nameless-earth-37809.herokuapp.com/login",
      { email }
    );
    localStorage.setItem("accessToken", data.token);
  };
  if (user) {
    navigate(from, { replace: true });
  }
  return (
    <div className="login-container container w-50 mx-auto">
      <h2 className="text-primary text-center mt-5">Please Login</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            required
            ref={emailRef}
            type="email"
            placeholder="Enter email"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            required
            ref={passwordRef}
            type="password"
            placeholder="Password"
          />
        </Form.Group>
        {!user ? error?.message : ""}
        <Button variant="primary w-100 mx-auto d-block my-2 p-2 " type="submit">
          Login
        </Button>
      </Form>
      <p>
        Doesn't Have Account?{" "}
        <span
          className="text-primary label "
          role="button"
          onClick={navigateRegister}
        >
          Please Register
        </span>
      </p>
      <p>
        Forget Password?{" "}
        <span
          className="text-primary label "
          role="button"
          onClick={resetPassword}
        >
          Reset Password
        </span>
      </p>
      <SocialLogin></SocialLogin>
      <ToastContainer />
    </div>
  );
};

export default Login;
